import { Component, HostListener, OnDestroy, ViewContainerRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-timezone';
import { Subscription } from 'rxjs';

import { Dimension, WebApiResponse } from './shared/models/dto';
import { Header } from './shared/models/enum';
import { ApiService } from './shared/services/api.service';
import { ContainerService } from './shared/services/container.service';
import { HeaderService } from './shared/services/header.service';
import { LocalStorageService } from './shared/services/local-storage.service';
import { LocalizationService } from './shared/services/localization.service';
import { UtilityService } from './shared/services/utility.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

  public showScrollToTopButton: boolean = true;
  public scrollToTopVisible: boolean = false;
  public sub: Subscription;
  public sub1: Subscription;
  public sub2: Subscription;
  public sub3: Subscription;
  public enumHeader = Header;
  public timer: NodeJS.Timeout = null;
  public previousSize: Dimension = new Dimension();

  public color: string = '#004987';

  public initialized: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let size = new Dimension();
    size.width = window.innerWidth;
    size.height = window.innerHeight;

    if (this.timer == null) {
      this.timer = setTimeout(() => {
        if (size.height != this.previousSize.height || size.width != this.previousSize.width) {
          this.previousSize.width = size.width;
          this.previousSize.height = size.height;
          this.containerService.dimension = size;
          this.containerService.windowResizeEvent.emit(size);
          this.containerService.isMobile = size.width < 992;
        }

        this.timer = null;
      }, 500);
    }
  }

  constructor(public localizationService: LocalizationService,
    private translateService: TranslateService,
    private utility: UtilityService,
    private apiService: ApiService,
    public headerService: HeaderService,
    public containerService: ContainerService,
    public viewContainerRef: ViewContainerRef,
    private localStorage: LocalStorageService,
    private router: Router) {

    this.utility.setIsLoading(true);

    this.translateService.setDefaultLang('it');

    this.apiService.getLingue().subscribe((rs: WebApiResponse) => {
      this.localizationService.languages = rs.data;
      this.localizationService.languagesSBM = this.localizationService.languages.filter(x => x.codice == 'it' || x.codice == 'en');
      this.localizationService.setDefaultLang(this.localStorage.get('language'), true).then(() => {
        this.initialized = true;
        this.utility.setIsLoading(false);
      });
    });

    moment.tz.setDefault('Europe/Rome');

    this.sub = containerService.scrollEvent.subscribe((x: number) => {
      if (x > 0) {
        this.scrollToTopVisible = true;
      } else {
        this.scrollToTopVisible = false;
      }
    });

    this.sub1 = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.scrollToTopVisible = false;
      }
    });

    this.sub2 = containerService.colorEvent.subscribe((color: string) => {
      setTimeout(() => {
        this.color = color;
      });
    });

    this.sub3 = containerService.showScrollToTopButtonEvent.subscribe((showScrollToTopButton: boolean) => {
      setTimeout(() => {
        this.showScrollToTopButton = showScrollToTopButton;
      }, 200);
    });

    setTimeout(() => {
      let dimension = new Dimension();
      dimension.width = window.innerWidth;
      dimension.height = window.innerHeight;
      this.containerService.dimension = dimension;
      this.containerService.isMobile = dimension.width < 992;
    }, 200);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.sub1.unsubscribe();
    this.sub2.unsubscribe();
    this.sub3.unsubscribe();
  }
}